import { render, staticRenderFns } from "./RimconfigCarSelectorVersion.vue?vue&type=template&id=42667cef"
import script from "./RimconfigCarSelectorVersion.vue?vue&type=script&lang=js"
export * from "./RimconfigCarSelectorVersion.vue?vue&type=script&lang=js"
import style0 from "./RimconfigCarSelectorVersion.vue?vue&type=style&index=0&id=42667cef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports